module.exports = __webpack_public_path__ + "static/media/login-icon-dark.dc69bbb2.svg";